

export const image_host="/eye/imgcode"
export const eyeurl="/eye/eyecode"
